import { render } from "./tag_preview_tag.vue?vue&type=template&id=a3e1f03a"
import script from "./tag_preview_tag.vue?vue&type=script&lang=js"
export * from "./tag_preview_tag.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
var __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__